type IntegrationQueryKey = 'integration' | 'all-integrations' | 'integration-check';

export const INTEGRATIONS_KEY = {
  INTEGRATION: 'integration' as IntegrationQueryKey,
  ALL_INTEGRATIONS: 'all-integrations' as IntegrationQueryKey,
  INTEGRATION_CHECK: 'integration-check' as IntegrationQueryKey,
};
